// @flow
import React from 'react';

import './supporters.css';

const Public = (props) => {
  let image;

  // set avatar if there is one.
  if (props.profileImageUrl) {
    image = (
      <span className="avatar boy with-avatar">
        <img
          alt="user avatar"
          src={props.profileImageUrl}
          style={{
            objectFit: 'cover',
            verticalAalign: 'middle',
            borderRadius: '50%',
            overflow: 'hidden',
            height: '60px',
            width: '60px',

          }}
        />
      </span>
    );
  } else if (props.gender === 'girl') { // default icons here
    image = (
      <span className={`avatar ${props.gender}`}>
        <span id="spanGirl" className="icon-large icon-owl-girl" />
      </span>
    );
  } else {
    image = (
      <span className="avatar boy">
        <span id="spanBoy" className="icon-large icon-owl-boy" />
      </span>
    );
  }

  return (
    <>
      {image}
      <div className="nowrap name">
        {props.nickname || props.fullName}
      </div>
    </>
  );
};

const Anonymous = (props) => (
  <>
    <span className="avatar adult">
      <span id="spanGlasses" className="icon-large icon-adult-glasses" />
    </span>
    <div className="nowrap name">
      Anonymous
    </div>
  </>
);

const Supporter = (props) => (
  props.isPublicProfile === true
    ? <Public {...props} /> : <Anonymous {...props} />
);

const Supporters = (props: Props) => {
  if (!props.data || props.data.length === 0) {
    return null;
  }

  return (
    <>
      <section className="dashboard-bottom-section friends-section">
        <div className="container">
          {
            props.title && <h3>{props.title}</h3>
          }
          <div className="friends">
            {
              props.data.map((investor) => (
                <span className="friend">
                  <Supporter {...investor} />
                </span>
              ))
            }
          </div>
        </div>
      </section>
    </>
  );
};

export default Supporters;
